import { UseFormReturn, FieldValues, Path } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  NativeSelect,
  Typography,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import {
  FREQUENCY_OPTIONS,
  TIME_SELECT_OPTIONS,
  DAY_OF_WEEK_OPTIONS,
  DAY_OF_MONTH_OPTIONS,
} from "../DatastoreAdd/DatastoreConnections/scheduleUtils";

interface ScheduleFormFieldsProps<T extends FieldValues> {
  form: UseFormReturn<T>;
}

export const ScheduleFormFields = <T extends FieldValues>({ form }: ScheduleFormFieldsProps<T>) => {
  const scheduleFrequency = form.watch("schedule_frequency" as Path<T>);

  return (
    <>
      <div className="al-border-t al-pt-4 al-mt-2">
        <Typography variant="body" weight="regular">
          Sync Schedule
        </Typography>
      </div>

      <Stack direction="row" gap="md">
        <FormField
          control={form.control}
          name={"schedule_frequency" as Path<T>}
          render={({ field }) => (
            <FormItem className="al-flex-1">
              <FormLabel>Update Frequency</FormLabel>
              <FormControl>
                <NativeSelect
                  options={FREQUENCY_OPTIONS}
                  value={field.value as string}
                  onChange={field.onChange}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {scheduleFrequency === "weekly" && (
          <FormField
            control={form.control}
            name={"schedule_day_of_week" as Path<T>}
            render={({ field }) => (
              <FormItem className="al-flex-1">
                <FormLabel>Day</FormLabel>
                <FormControl>
                  <NativeSelect
                    options={DAY_OF_WEEK_OPTIONS}
                    value={field.value as string}
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}

        {scheduleFrequency === "monthly" && (
          <FormField
            control={form.control}
            name={"schedule_day_of_month" as Path<T>}
            render={({ field }) => (
              <FormItem className="al-flex-1">
                <FormLabel>Day</FormLabel>
                <FormControl>
                  <NativeSelect
                    options={DAY_OF_MONTH_OPTIONS}
                    value={field.value as string}
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}

        <FormField
          control={form.control}
          name={"schedule_time" as Path<T>}
          render={({ field }) => (
            <FormItem className="al-flex-1">
              <FormLabel>Time (UTC)</FormLabel>
              <FormControl>
                <NativeSelect
                  options={TIME_SELECT_OPTIONS}
                  value={field.value as string}
                  onChange={field.onChange}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </Stack>
    </>
  );
};
